import React, { useEffect } from "react";
import classNames from "classnames";
import type { DraggableSyntheticListeners } from "@dnd-kit/core";
import type { Transform } from "@dnd-kit/utilities";

export interface Props {
  dragOverlay?: boolean;
  disabled?: boolean;
  dragging?: boolean;
  handle?: boolean;
  handleProps?: any;
  height?: number;
  index?: number;
  fadeIn?: boolean;
  transform?: Transform | null;
  listeners?: DraggableSyntheticListeners;
  sorting?: boolean;
  style?: React.CSSProperties;
  transition?: string | null;
  wrapperStyle?: React.CSSProperties;
  value: React.ReactNode;
}

export const Item = React.memo(
  React.forwardRef<HTMLDivElement, Props>((properties, ref) => {
    const {
      dragOverlay,
      disabled,
      dragging,
      handle,
      handleProps,
      height,
      index,
      listeners,
      sorting,
      style,
      transition,
      transform,
      value,
      wrapperStyle,
      fadeIn,
      ...props
    } = properties;

    useEffect(() => {
      if (!dragOverlay) {
        return;
      }

      document.body.style.cursor = "grabbing";

      return () => {
        document.body.style.cursor = "";
      };
    }, [dragOverlay]);

    return (
      <div
        style={{
          transition: [transition].filter(Boolean).join(", "),
          transform: `translate3d(${
            transform ? `${Math.round(transform.x)}px` : "0"
          }, ${transform ? `${Math.round(transform.y)}px` : "0"}, 0) scaleX(${
            transform?.scaleX || 1
          }) scaleY(${transform?.scaleY || 1})`,
          transformOrigin: "0 0",
        }}
        ref={ref}
      >
        <div
          data-cypress="draggable-item"
          className={classNames(
            // 拖拽状态
            dragging && !dragOverlay && "opacity-50 z-0",
            // 禁用状态
            disabled &&
              "text-gray-400 bg-gray-100 cursor-not-allowed focus:shadow-[0_0_4px_1px_rgba(0,0,0,0.1),0_0_0_1px_rgba(63,63,68,0.05),0_1px_3px_0_rgba(34,33,81,0.15)]",
            // dragOverlay 状态
            dragOverlay && "cursor-inherit animate-pop opacity-100"
          )}
          {...listeners}
          {...props}
          style={style}
        >
          {value}
        </div>
      </div>
    );
  })
);
